import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AlertMessageIcon from './AlertMessageIconProp';

interface Props {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  fallbackLinkUrl?: string;
  fallbackLinkText?: string;
  showTimer?: boolean;
  timerDuration?: number;
  autoRedirect?: boolean;
}

export default function EmptyMessage({
  message = 'No content available at the moment.',
  fallbackLinkUrl,
  fallbackLinkText,
  showTimer = false,
  timerDuration = 5,
  autoRedirect = false,
  size = 'lg',
}: Props) {
  const [countdown, setCountdown] = useState(timerDuration);

  useEffect(() => {
    if (!showTimer || !fallbackLinkUrl) return;

    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          if (autoRedirect) {
            window.location.href = fallbackLinkUrl;
          }
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [showTimer, fallbackLinkUrl, autoRedirect]);

  const getTimerMessage = () => {
    if (countdown > 0) {
      return `You will be redirected to your iknowly dashboard `;
    }
    return autoRedirect ? 'Redirecting...' : 'Timer expired';
  };

  return (
    <div className="flex flex-col items-center justify-center text-center p-6">
      <div className="mb-4 scale-150">
        <AlertMessageIcon size={size} />
      </div>

      <p className="text-xl font-semibold text-gray-800">{message}</p>

      {showTimer && fallbackLinkUrl && (
        <div className="mt-6 flex flex-col items-center gap-3">
          <div className="w-16 h-16 flex items-center justify-center rounded-full border-[5px] border-[#CC4202] animate-pulse">
            <span className="text-2xl font-bold text-[#CC4202]">{countdown}</span>
          </div>
          <p className="text-sm text-gray-600">{getTimerMessage()}</p>
        </div>
      )}

      {fallbackLinkUrl && fallbackLinkText && (
        <div className="mt-6">
          <Link to={fallbackLinkUrl} className="text-primary underline text-base font-medium">
            {fallbackLinkText}
          </Link>
        </div>
      )}
    </div>
  );
}
